import { Box, Typography, styled } from "@mui/material";
import { APP_BACKGROUND_COLOR ,APP_COLOR, APP_HOVER_COLOR, FONT_FAMILY} from "../../theme";

export const styles = {
  contributorNavLink: {
    marginRight: "10px",
    marginLeft: "10px",
    textDecoration: "none",
    fontFamily: FONT_FAMILY,
    color: APP_COLOR,
  } as const,
  contributorsPhotos: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    marginTop: "-5px",
    marginBottom: "5px",
    backgroundColor: APP_HOVER_COLOR,
  } as const,
  playbackIcons: { height: 25, width: 25 } as const,
  horizontalLine: {
    border: "1px solid #9FA4A9",
    marginBottom: "10px",
  } as const,
  ownerContainer: {
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
  } as const,
  buttonsContainer: {
    display: "flex",
    justifyContent: "center",
    padding: "10px",
  } as const,
  trackVersionContainer: {
    display: "flex",
    marginBottom: "10px",
  } as const,
  tableTd: {
    padding: "10px",
    textAlign: "center",
  } as const,
  iconButtonsContainer: {
    display: "flex",
    justifyContent: "right",
    marginTop: "-10px",
  } as const,
  linearProgressContainer: {
    width: "100%",
    color: APP_COLOR,
    height: "20vh",
    paddingTop: 10,
  } as const,
  linearProgressMainContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "0px 10px 5px 10px",
    fontFamily: FONT_FAMILY,
    margin: "40px 0",
  },
};

export const TrackVersionsDetailsBox = styled(Box)(({ theme }) => ({
  display: "flex",
  backgroundColor: "#C1b2b",
  boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.8)",
  justifyContent: "space-between",
  padding: "10px",
  margin: "20px",
  [theme.breakpoints.down("sm")]: {
    minWidth: "1200px",
  },
}));

export const InfoContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  width: "150px",
  padding: "15px",
  [theme.breakpoints.down("lg")]: {
    width: "100px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100px",
    height: "80px",
    minWidth: "200px",
  },
}));

export const FirstColumnInfoContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  width: "150px",
  padding: "15px",
  [theme.breakpoints.down("lg")]: {
    width: "100px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100px",
    height: "80px",
    minWidth: "200px",
    position: "sticky",
    left: 0,
    backgroundColor: APP_BACKGROUND_COLOR,
    zIndex: 2,
  },
}));

export const VersionDetailsBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "left",
  width: "auto",
  padding: "5px 2px 5px 2px",
  borderBottom: "1px solid #9FA4A9",
  margin: "5px 2px 5px 2px",
  [theme.breakpoints.down("md")]: {
    fontSize: 13,
  },
}));

export const LabelsBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  width: "50px",
  borderRadius: 10,
  padding: "12px 20px 12px 40px",
  boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.8)",
  overflow: "hidden",
  marginBottom: 20,
  [theme.breakpoints.down("md")]: {
    padding: "8px 0px 8px 16px",
    fontSize: 13,
  },
}));

export const LabelDateBox = styled(Box)(({ theme }) => ({
  display: "flex",
  whiteSpace: "nowrap",
  overflow: "hidden",
  width: "calc(100%)",
  textOverflow: "ellipsis",
  marginLeft: "auto",
  fontSize: 15,
  alignItems: "center",
  justifyContent: "space-around",
  [theme.breakpoints.down("md")]: {
    marginRight: 25,
    marginLeft: 10,
    fontSize: 13,
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
}));

export const TimeBox = styled(Box)(({ theme }) => ({
  display: "flex",
  width: 350,
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const IconBox = styled(Box)(({ theme }) => ({
  display: "flex-end",
}));

export const SingleTrackContainer = styled(Box)(({ theme }) => ({
  padding: "40px 10px 10px 10px",
}));

export const NameText = styled(Typography)(({ theme }) => ({
  display: "flex",
  fontFamily: FONT_FAMILY,
  fontWeight: "bold",
  width: 300,
  justifyContent: "center",
  [theme.breakpoints.down("md")]: {
    fontSize: 12,
    justifyContent: "flex-start",
  },
}));

export const DateText = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  display: "flex",
  marginLeft: 30,
  justifyContent: "center",
  textAlign: "center",
  width: 200,
  [theme.breakpoints.down("md")]: {
    fontSize: 10,
    marginLeft: 0,
    justifyContent: "flex-start",
    textAlign: "inherit",
  },
}));

export const InlineSize = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  display: "none",
  marginLeft: 20,
  textAlign: "center",
  width: 200,
  [theme.breakpoints.down("md")]: {
    display: "flex",
    fontSize: 10,
    marginLeft: 0,
    textAlign: "inherit",
    fontWeight: "bold",
  },
}));

export const LabelText = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  textAlign: "center",
  margin: "0 10px",
  width: 300,
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const TypeText = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  textAlign: "center",
  width: 115,
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));
